import React, { memo } from "react";

const DoubleLegend = memo(() => (
  <div className="legend-grid-container">
    <div className="row">
      <div className="col-xs-12 legendRow">
        <div className="legendBox col-md-2">
          <span className="skeleton title"></span>
          <span className="skeleton title"></span>
          <span className="skeleton title"></span>
        </div>
        <div className="legended-sign-panel-container col-md-10">
          {[...Array(2).keys()].map((_, i) => (
            <div
              className="legended-sign-panel double col-xs-6 col-md-5"
              key={`double-panel-${i}`}
            >
              <div className="signBox" style={{ width: "100%" }}>
                <div className="content-container">
                  <div
                    className="putalegend product-quantity col-xs-12"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="col-xs-5"
                      style={{ alignContent: "center" }}
                    >
                      <div className="skeleton image-double"></div>
                    </div>
                    <div className="col-xs-7">
                      <div className="skeleton spacer-25"></div>
                      <div className="skeleton textline"></div>
                      <div className="skeleton textline"></div>
                      <div className="skeleton blob"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
));

const SingleLegend = memo(() => (
  <div className="legend-grid-container">
    <div className="row">
      <div className="col-xs-12 legendRow">
        <div className="legendBox col-md-2">
          <span className="skeleton title"></span>
          <span className="skeleton title"></span>
          <span className="skeleton title"></span>
        </div>
        <div className="legended-sign-panel-container col-md-10">
          <div className="legended-sign-panel single col-xs-12 col-md-8">
            <div className="signBox">
              <div className="content-container">
                <div className="col-xs-12 col-md-5">
                  <div className="image-container">
                    <div className="skeleton image"></div>
                  </div>
                </div>
                <div className="putalegend product-quantity col-xs-12 col-md-7">
                  <div className="skeleton spacer-25"></div>
                  <div className="skeleton textline"></div>
                  <div className="skeleton textline"></div>
                  <div className="skeleton blob"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
));

const Skeleton = ({ pagetype }) => {
  const isDouble = pagetype === "double";

  return (
    <>
      {/* <div className="legend-price-grid col-xs-12 legendHeader price-grid" style={{ padding: "0" }}>
        <div className="skeleton blob" style={{ padding: "none" }}></div>
      </div> */}
      <div className="panel-body">
        <div className="row search-box vertical-align">
          <img
            src="//media.trafficsafetystore.com/image/upload/images/newlegendview-hero-1920.webp"
            alt="hero image"
          />

          <div className="col-xs-12">
          <span className="skeleton title" style={{maxWidth:'600px',margin:'5px auto',display:'block'}}></span>
          </div>
          <div className="col-xs-12">
          <span className="skeleton title" style={{maxWidth:'600px',margin:'5px auto',display:'block'}}></span>
          </div>
        </div>
      </div>
      <div className="legend-price-grid col-xs-12 legendHeader price-grid">
        <div className="skeleton blob"></div>
        <div className="col-xs-6 col-md-5 legend-price-grid-outer"></div>
        <div className="col-xs-6 col-md-5 legend-price-grid-outer"></div>
        {isDouble && (
          <div className="double">
            <div className="col-xs-12 legendHeader header no-pad-992">
              <div className="legend-product-type">
                <div className="col-sm-12 col-md-2 legendsHeaderBox"></div>
                <div className="col-sm-6 col-md-5 hidden-xs hidden-sm legend-price-grid-outer signTypeHeader">
                  <div className="skeleton title"></div>
                </div>
                <div className="col-sm-6 col-md-5 hidden-xs hidden-sm legend-price-grid-outer signTypeHeader">
                  <div className="skeleton title"></div>
                </div>
              </div>
            </div>
          </div>
        )}
        {!isDouble && <div className="col-xs-12 skeleton title "></div>}
      </div>
      {[...Array(3).keys()].map((i) =>
        isDouble ? (
          <DoubleLegend key={`double-${i}`} />
        ) : (
          <SingleLegend key={`single-${i}`} />
        )
      )}
    </>
  );
};

export default Skeleton;
